{
  "eyebrow": "Изберете своя план",
  "title": "Планът, който отговаря на начина, по който работи екипът ви.",
  "sub": "30 дни безплатен пробен период за всеки план. Без кредитна карта. Отказ по всяко време.",
  "bill": {
    "month": "Месечно",
    "year": "Годишно",
    "save": "Спестете ~17%"
  },
  "fam": {
    "time": "Време и операции",
    "project": "Проекти и контрол на разходите"
  },
  "compare": "Сравни всички функции",
  "compareHide": "Скрий сравнението",
  "included": "Включено",
  "select": "Избери {{plan}}",
  "selected": "Избрано",
  "recommended": "Най-популярен",
  "pricePerMonth": "/ потребител / месец",
  "pricePerYear": "/ потребител / година",
  "base": "база / месец",
  "admins": "2 администратора са включени",
  "continueCta": "Продължи с {{plan}}",
  "continuePick": "Изберете план, за да продължите",
  "catalogError": "Каталогът с цени е недостъпен. Опитайте отново, за да заредите най-новите цени.",
  "plans": {
    "timeBasic": "Time Basic",
    "timePro": "Time Pro",
    "projectBasic": "Project Basic",
    "projectPro": "Project Pro",
    "timeBasicBest": "Съответствие и просто отчитане",
    "timeProBest": "Екипни операции",
    "projectBasicBest": "Проекти и контрол на разходите",
    "projectProBest": "Разширено управление на проекти",
    "feat": {
      "timeBasic": {
        "timeTracking": "Регистриране на работно време",
        "absencesHolidays": "Отсъствия и отпуски",
        "transport": "Транспортни записи",
        "workLocations": "Работни места и GPS",
        "mobileApp": "Мобилно приложение за работници на терен"
      },
      "timePro": {
        "everythingTime": "Всичко от Time Basic",
        "overtime": "Регистриране на извънреден труд",
        "scheduling": "Планиране на смени",
        "documents": "Документи на служителите",
        "officeOps": "Офис функции (дневник на активност, корекции)",
        "addonsAvailable": "Налични добавки: проследяване на проекти, VTT",
        "internalMessaging": "Вътрешни съобщения (чат)"
      },
      "projectBasic": {
        "everythingTime": "Всичко от Time Basic",
        "projects": "Проекти с контрол на разходите",
        "extras": "Допълнителна работа и материали",
        "subcontractors": "Управление на подизпълнители",
        "checkInOut": "Чекиране на работници (вход / изход)",
        "internalMessaging": "Вътрешни съобщения (чат)"
      },
      "projectPro": {
        "everythingAll": "Всичко от Time Pro + Project Basic",
        "projectTransport": "Транспорт по проект",
        "fullSuite": "Пълен пакет за продуктивност",
        "prioritySupport": "Приоритетна поддръжка",
        "internalMessaging": "Вътрешни съобщения (чат)"
      }
    },
    "timeZero": "Time Zero"
  },
  "comparison": {
    "title": "Сравнете всички функции",
    "subtitle": "Всичко, което включва всеки план, едно до друго.",
    "cat": {
      "timeAttendance": "Време & присъствие",
      "projectCost": "Проект & контрол на разходите",
      "support": "Поддръжка"
    },
    "val": {
      "upTo4": "До 4",
      "unlimited": "Неограничено",
      "soon": "Скоро",
      "optional": "По избор",
      "years5": "5 години",
      "years10": "10 години"
    },
    "row": {
      "mobileDesktop": "Мобилно & настолно приложение",
      "gpsCheckin": "Отчитане с едно докосване чрез GPS",
      "holidayAbsenceOvertime": "Отпуск, отсъствия & извънреден труд",
      "teamMembers": "Членове на екипа",
      "workLocations": "Работни локации",
      "registrationsPerMonth": "Регистрации / потребител / месец",
      "irregularMap": "Нередовно отчитане на карта",
      "expenseManagement": "Управление на разходи",
      "employeeDocuments": "Документи на служители",
      "openApi": "Отворен API",
      "navigation": "Навигация до работните обекти",
      "projectManagement": "Управление на проекти (бюджет)",
      "subprojects": "Подпроекти",
      "subcontractorManagement": "Управление на подизпълнители",
      "extraWorkMaterials": "Допълнителна работа & материали",
      "transportProjects": "Транспорт, свързан с проекти",
      "fullSuite": "Пълен пакет за продуктивност",
      "prioritySupport": "Приоритетна поддръжка",
      "schedulingMessaging": "Планиране · Съобщения · Известия",
      "languages12": "Достъпно на 12 езика",
      "manualTransport": "Ръчно въведено транспортно разстояние",
      "reportsExcel": "Отчети и експорт в Excel",
      "frontendLocations": "Локации, създадени от потребителите на приложението",
      "checkInWork": "Check-in/out@work (Белгия)",
      "vehicleTracking": "Vehicle Track & Trace",
      "projectDescriptions": "Описания и снимки на проекти",
      "dataStorage": "Съхранение на данни"
    }
  }
}
